import {useTranslation} from "react-i18next";
import {Box, Grid} from '@mui/material';
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {monthNames} from '../Trans.js';
import {TAB_BL} from './TaxCommon.js';
import {blAreaList} from '../Bl.js';
import {COMM_OK} from '../WsR2.js';
import {TT_SPEC} from '../Util.js';

const TaxBlObligation = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const bl = gStorage.taxons.bl;
	let obl_str = '';

	if (!bl)
		return null;

	if (bl.month_mask === 0xfff) {
		obl_str = 'bl.obligation';
	} else if (bl.month_mask === 0) {
		if (bl.area_mask) {
			return null;
		}

		obl_str = 'bl.no_obligation';
	}

	return (
		<Grid size={{xs: 12}} align={'center'} sx={{mt: 2}}>
			<Box sx={{fontWeight: 'bold'}}>{t(obl_str)}</Box>
		</Grid>
	);
});

const TaxBlSeasonal = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	let i, range_start, ranges = [];
	const bl = gStorage.taxons.bl;

	if (!bl || bl.month_mask === 0 || bl.month_mask === 0xfff)
		return null;

	range_start = -1;

	for (i = 0; i < monthNames.length; i++) {
		if (bl.month_mask & (1 << i)) {
			if (range_start < 0) {
				range_start = i;
			}
		} else {
			if (range_start >= 0) {
				ranges.push({b:range_start, e:i-1});
				range_start = -1;
			}
		}
	}

	if (range_start > 0) {
		let found = false;

		for (i = 0; i < ranges.length; i++) {
			if (ranges[i].b === 0) {
				/* Merge */
				ranges[i].b = range_start;
				found = true;
				break;
			}
		}

		if (!found) {
			ranges.push({b:range_start, e:i-1});
		}
	}

	const rangeStr = 
		ranges.map((m, ind) => {
			let str = t(monthNames[m.b]);
			
			if (m.e !== m.b) {
				str += '-' + t(monthNames[m.e]);
			}

			if (ind < ranges.length - 1)
				str += ', ';

			return str;
		});

	return (
		<Grid size={{xs: 12}} align={'center'} sx={{mt:2}}>
			<Box sx={{fontWeight: 'bold'}}>{t('bl.seasonal_rarity')}</Box>
			<Box sx={{mt:1}}>{rangeStr}</Box>
		</Grid>
	);
});

const TaxBlRegional = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const bl = gStorage.taxons.bl;
	let regions = [], i;

	if (!bl || !bl.area_mask || bl.area_mask === 0xf)
		return null;

	for (i = 0; i < 4; i++) {
		if (bl.area_mask & (1 << i)) {
			regions.push(t(blAreaList[i].desc));
		}
	}

	const regStr = 
		regions.map((m, ind) => {
			let str = m;

			if (ind < regions.length - 1)
				str += ', ';
				return str;
		});

	return (
		<Grid size={{xs: 12}} align={'center'} sx={{mt:2}}>
			<Box sx={{fontWeight: 'bold'}}>{t('bl.regional_rarity')}</Box>
			<Box sx={{mt:1}}>{regStr}</Box>
		</Grid>
	);
});

const TaxBlInfo = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const bl = gStorage.taxons.bl;

	if (!bl || !bl.info.length)
		return null;

	return (
		<Grid size={{xs: 12}} align={'center'} sx={{mt:2}}>
			<Box sx={{fontWeight: 'bold'}}>{t('bl.info')}</Box>
			<Box sx={{mt:1}}>{bl.info}</Box>
		</Grid>
	);
});

const TaxBl = observer(() => {
	const gStorage = useGlobalStorage();

	function blRxWs(status, msg) {
		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('blRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'bl_load') {
// 			console.log('blRxWs, desc', msg.data);
			gStorage.taxons.setBl(msg.data.bl);
		} else {
			console.error('blRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadBl(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'bl_load',
			data: {
				taxon: {
					id: tax.id,
				}
			}
		};

// 		console.log('loadDesc', msg);
		gStorage.conn.ws.send(msg, blRxWs);
	};

	if (gStorage.taxons.tab !== TAB_BL)
		return null;

	let tax = gStorage.taxons.centerTaxon;
	if (!tax || tax.t_type > TT_SPEC) 
		return null;

	if (gStorage.taxons.bl === null && gStorage.conn.online) {
		loadBl(tax);
		return null;
	}

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:300}}>
			<TaxBlObligation/>
			<TaxBlSeasonal/>
			<TaxBlRegional/>
			<TaxBlInfo/>
		</Grid>
	);
});

export default TaxBl;
